import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/training/TrainingCatalog.tsx");
